<script>
export default {
    name: 'ResourceProgress',
    data(){
        return {
            currentProgress: null,
            currentIcon: null,
            currentNo: 0,
            response: null,
            hasBeen: [],
            loading: true,
        }
    },
    methods: {
        async getData(id){
            this.hasBeen = []
            this.loading = true;
            await this.$store.dispatch('apiresource/GetResourceProgress', id).then((res) => {
                if(res.data.error){
                    return this.showToast(res.data.errorMessage, 'error');
                }
                if(res.data.created){
                    this.currentProgress = `Created on ${this.formatDateWithTime(new Date(res.data.created))}`;
                    this.currentIcon = 'mdi-clipboard-edit-outline';
                    this.currentNo = 0;
                }
                if(res.data.technicalReview){
                    this.currentProgress = `Technically Reviewed on ${this.formatDateWithTime(new Date(res.data.technicalReview))}`;
                    this.currentIcon = 'mdi-account-tie';
                    this.currentNo = 1
                    this.hasBeen.push(1);
                }
                if(res.data.app){
                    this.currentProgress = `APP was approved on ${this.formatDateWithTime(new Date(res.data.app))}`;
                    this.currentIcon = 'mdi-account-arrow-right-outline';
                    this.currentNo = 1.5
                    this.hasBeen.push(2);
                }
                if(res.data.pr){
                    this.currentProgress = `Purchase Request was created on ${this.formatDateWithTime(new Date(res.data.pr))}`;
                    this.currentIcon = 'mdi-clipboard-file-outline';
                    this.currentNo = 2
                }
                if(res.data.rfq){
                    this.currentProgress = `Request for Quotation was created on ${this.formatDateWithTime(new Date(res.data.rfq))}`;
                    this.currentIcon = 'mdi-clipboard-list-outline';
                    this.currentNo = 3
                }
                if(res.data.award){
                    this.currentProgress = `Supplier was awarded on ${this.formatDateWithTime(new Date(res.data.award))}`;
                    this.currentIcon = 'mdi-certificate-outline';
                    this.currentNo = 4
                }
                if(res.data.po){
                    this.currentProgress = `Purchase Order was created on ${this.formatDateWithTime(new Date(res.data.po))}`;
                    this.currentIcon = 'mdi-package-variant';
                    this.currentNo = 5
                }
                if(res.data.delivery){
                    this.currentProgress = `Order was delivered on ${this.formatDateWithTime(new Date(res.data.delivery))}`;
                    this.currentIcon = 'mdi-package-variant';
                    this.currentNo = 6
                }
                this.response = res.data;
            }).catch((e) => {
                this.showToast('Something went wrong!', 'error');
            })
            this.loading = false;
        },
        showProgress(number){
            if(number > this.currentNo){
                return;
            }
            if(number == 0){
                this.currentProgress = `Created on ${this.formatDateWithTime(new Date(this.response.created))}`;
                this.currentIcon = 'mdi-clipboard-edit-outline';
            }
            if(number == 1){
                this.currentProgress = `Technically Reviewed on ${this.formatDateWithTime(new Date(this.response.technicalReview))}`;
                this.currentIcon = 'mdi-account-tie';
            }
            if(number == 1.5){
                this.currentProgress = `APP was approved on ${this.formatDateWithTime(new Date(this.response.app))}`;
                this.currentIcon = 'mdi-account-arrow-right-outline';
            }
            if(number == 2){
                this.currentProgress = `Purchase Request was created on ${this.formatDateWithTime(new Date(this.response.pr))}`;
                this.currentIcon = 'mdi-clipboard-file-outline';
            }
            if(number == 3){
                this.currentProgress = `Request for Quotation was created on ${this.formatDateWithTime(new Date(this.response.rfq))}`;
                this.currentIcon = 'mdi-clipboard-list-outline';
            }
            if(number == 4){
                this.currentProgress = `Supplier was awarded on ${this.formatDateWithTime(new Date(this.response.award))}`;
                this.currentIcon = 'mdi-certificate-outline';
            }
            if(number == 5){
                this.currentProgress = `Purchase Order was created on ${this.formatDateWithTime(new Date(this.response.po))}`;
                this.currentIcon = 'mdi-package-variant';
            }
            if(number == 6){
                this.currentProgress = `Order was delivered on ${this.formatDateWithTime(new Date(this.response.delivery))}`;
                this.currentIcon = 'mdi-package-variant';
            }
        },
        closeModal(){
            this.$emit('close');
        }
    },
}
</script>
<template>
    <div v-if="loading">
        <div class="m-2 p-2 progress-card">
            <div class="mb-2 text-center">
                <div class="current-progress">
                    <h3>Current progress</h3>
                    <div class="d-flex flex-column align-items-center">
                        <b-skeleton width="70px" height="70px" class="bg-primary bg-soft mb-4"></b-skeleton>
                        <b-skeleton width="300px" height="15px" class="bg-primary bg-soft mb-4"></b-skeleton>
                        <b-skeleton width="90%" height="180px" class="bg-primary bg-soft"></b-skeleton>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="m-2 p-2 progress-card">
            <div class="mb-2 text-center">
                <div class="current-progress">
                    <h3>Current progress</h3>
                    <i class="mdi w-100 text-white" :class="`${currentIcon}`"></i>
                    <h5 class="font-size-14 text-muted">{{currentProgress && currentProgress}}</h5>
                </div>
            </div>
            <div class="d-flex justify-content-center my-5 parent-div">
                <div class="prog-div text-center text-glow-success cursor-pointer" @click="showProgress(0)">
                    <div class="circle justify-content-center d-flex align-items-center">
                        <i class="mdi mdi-clipboard-edit-outline w-100" ></i>
                    </div>
                    <p class="mb-0 mt-2">Created</p>
                </div>
                <div class="horizontal-small-line" :class="{'success': currentNo >= 0, 'position-relative glow-line': currentNo == 0}"><div></div></div>
                <!-- <div class="vertical-big-line">
                    <div class="top" :class="{'success': currentNo >= 0 && hasBeen.includes(1)}"></div>
                    <div class="bottom" :class="{'success': currentNo >= 0 && hasBeen.includes(2)}"></div>
                </div> -->
                <!-- <div class="multiple-line">
                    <div class="top-line" :class="{'success': currentNo >= 0 && hasBeen.includes(1)}"></div>
                    <div class="bottom-line" :class="{'success': currentNo >= 0 && hasBeen.includes(2)}"></div>
                </div>
                <div class="multiple-circle">
                    <div class="top">
                        <div class="position-relative w-100" :class="{'text-glow-success': currentNo >= 1 && hasBeen.includes(1), 'quarter-success': currentNo == 0 && hasBeen.includes(1), 'cursor-pointer': currentNo >= 1 && hasBeen.includes(1)}" @click="showProgress(1)">
                            <div class="small-circle justify-content-center d-flex align-items-center">
                                <i class="mdi mdi-account-tie w-100 small" ></i>
                            </div>
                            <p class="position-absolute text-center absolute-centerX">Technical Review</p>
                        </div>
                    </div>
                    <div class="bottom">
                        <div class="position-relative w-100" :class="{'text-glow-success': currentNo >= 1 && hasBeen.includes(2), 'quarter-success': currentNo == 0 && hasBeen.includes(2), 'cursor-pointer': currentNo >= 1 && hasBeen.includes(2)}" @click="showProgress(1)">
                            <div class="small-circle justify-content-center d-flex align-items-center">
                                <i class="mdi mdi-account-arrow-right-outline w-100 small" ></i>
                            </div>
                            <p class="position-absolute text-center absolute-centerX">APP</p>
                        </div>
                    </div>
                </div>
                <div class="multiple-line">
                    <div class="top-line" :class="{'success': currentNo >= 1 && hasBeen.includes(1)}"></div>
                    <div class="bottom-line" :class="{'success': currentNo >= 1 && hasBeen.includes(2)}"></div>
                </div> -->
                <!-- <div class="vertical-big-line">
                    <div class="top" :class="{'success': currentNo >= 1 && hasBeen.includes(1)}"></div>
                    <div class="bottom" :class="{'success': currentNo >= 1 && hasBeen.includes(2)}"></div>
                </div> -->
                <div class="prog-div text-center" :class="{'text-glow-success': currentNo >= 1 && hasBeen.includes(2), 'quarter-success': currentNo == 0 && hasBeen.includes(2), 'cursor-pointer': currentNo >= 1 && hasBeen.includes(2)}" @click="showProgress(1.5)">
                    <div class="circle justify-content-center d-flex align-items-center">
                        <i class="mdi mdi-account-arrow-right-outline w-100" ></i>
                    </div>
                    <p class="mb-0 mt-2">APP</p>
                </div>
                <div class="horizontal-small-line" :class="{'success': currentNo >= 1, 'position-relative glow-line': currentNo == 1}" ><div></div></div>
                <div class="prog-div text-center" :class="{'text-glow-success': currentNo >= 2, 'quarter-success': currentNo >= 1 && hasBeen.includes(2), 'cursor-pointer': currentNo >= 2}" @click="showProgress(2)">
                    <div class="circle justify-content-center d-flex align-items-center">
                        <i class="mdi mdi-clipboard-file-outline w-100" ></i>
                    </div>
                    <p class="mb-0 mt-2">Purchase Request</p>
                </div>
                <div class="horizontal-small-line" :class="{'success': currentNo >= 2, 'position-relative glow-line': currentNo == 2}"><div></div></div>
                <div class="prog-div text-center" :class="{'text-glow-success': currentNo  >= 3, 'quarter-success': currentNo == 2, 'cursor-pointer': currentNo >= 3}" @click="showProgress(3)">
                    <div class="circle justify-content-center d-flex align-items-center">
                        <i class="mdi mdi-clipboard-list-outline w-100" ></i>
                    </div>
                    <p class="mb-0 mt-2">Request for Quotation</p>
                </div>
                <div class="horizontal-small-line" :class="{'success': currentNo >= 3, 'position-relative glow-line': currentNo == 3}" ><div></div></div>
                <div class="prog-div text-center" :class="{'text-glow-success': currentNo >= 4, 'quarter-success': currentNo == 3, 'cursor-pointer': currentNo >= 4}" @click="showProgress(4)">
                    <div class="circle justify-content-center d-flex align-items-center">
                        <i class="mdi mdi-certificate-outline w-100" ></i>
                    </div>
                    <p class="mb-0 mt-2">Awards</p>
                </div>
                <div class="horizontal-small-line" :class="{'success': currentNo >= 4, 'position-relative glow-line': currentNo == 4}" ><div></div></div>
                <div class="prog-div text-center" :class="{'text-glow-success': currentNo >= 5, 'quarter-success': currentNo == 4, 'cursor-pointer': currentNo >= 5}" @click="showProgress(5)">
                    <div class="circle justify-content-center d-flex align-items-center">
                        <i class="mdi mdi-package-variant w-100" ></i>
                    </div>
                    <p class="mb-0 mt-2">Purchase Order</p>
                </div>
                <div class="horizontal-small-line" :class="{'success': currentNo >= 5, 'position-relative glow-line': currentNo == 5}"><div></div></div>
                <div class="prog-div text-center" :class="{'text-glow-success': currentNo >= 6, 'quarter-success': currentNo == 5, 'cursor-pointer': currentNo >= 6}" @click="showProgress(6)">
                    <div class="circle justify-content-center d-flex align-items-center">
                        <i class="mdi mdi-truck-fast-outline w-100" ></i>
                    </div>
                    <p class="mb-0 mt-2">Delivery</p>
                </div>
            </div>
        </div>
    </div>
</template>